module.exports = __webpack_public_path__ + "static/media/m_sf_15.b62a80a1.png";